import config from "../config";
import { HOTEL_API_CONFIG } from "./hotelApi";
import { FLIGHT_API_CONFIG } from "./flightApi";
import { TOUR_API_CONFIG } from "./tourApi";
import { PROFILE_API_CONFIG } from "./profileApi";
import { COLLABORATION_AGENCY_API_CONFIG } from "./collaborationAgencyApi";
import { CONTENT_API_CONFIG } from "./contentApi";

const { baseApiURL } = config;

const clientApiBaseUrl = "/api";
const serverApiBaseUrl = `${process.env.DOMAIN}/api`;

const api = {
  public: {
    discount: {
      client: `${clientApiBaseUrl}/discount`,
      back: `${baseApiURL}v1/discounts/validate`,
    },
    recentPassengers: `${baseApiURL}v1/passengers`,
    pay: {
      client: `${clientApiBaseUrl}/order/pay`,
      back: `${baseApiURL}v1/pay`,
    },
    nationality: `${baseApiURL}v1/nationality`,
    ticketCaches: `${baseApiURL}flight/v1/ticket-caches`,
    gateways: `${baseApiURL}v1.1/gateways`,
    seo: (...slugs: (string | number)[]) =>
      `${baseApiURL}content/v1/pages/${slugs.join("-")}`,
    flightDestinationPage: (destinationCityId: number) =>
      `${baseApiURL}content/v1/flight-destination-pages/${destinationCityId}`,
    robots: `${baseApiURL}content/v1/robots-txt`,
    sitemap: `${baseApiURL}content/v1/sitemap-xml`,
    settings: {
      client: `${serverApiBaseUrl}/settings`,
      back: `${baseApiURL}v1.1/settings`,
    },
    banners: {
      page: (pageKey: string) =>
        `${baseApiURL}v1/banners/pages/${encodeURIComponent(pageKey)}`,
    },
  },
  profile: PROFILE_API_CONFIG,
  flight: FLIGHT_API_CONFIG,
  hotel: HOTEL_API_CONFIG,
  tour: TOUR_API_CONFIG,
  collaborationAgency: COLLABORATION_AGENCY_API_CONFIG,
  content: CONTENT_API_CONFIG,
};

export default api;
